import { ChangeEvent, FocusEvent } from "react";
import { useFormContext } from "react-hook-form";

type SaveFunction = FocusEvent<HTMLInputElement | HTMLTextAreaElement> | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>

export const useSaveValuesFromField = (filedName: string) => {
  const { setValue } = useFormContext();

  const handleSaveToMappedField = ({ target: { value } }: SaveFunction) => { 
    setValue(filedName, value)
  }
  return handleSaveToMappedField
}
